import { render, staticRenderFns } from "./Colissimo.vue?vue&type=template&id=2d02879a&scoped=true&"
import script from "./Colissimo.vue?vue&type=script&lang=js&"
export * from "./Colissimo.vue?vue&type=script&lang=js&"
import style0 from "./Colissimo.vue?vue&type=style&index=0&id=2d02879a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d02879a",
  null
  
)

export default component.exports